import { Button, Modal } from 'antd';
import { CrownOutlined } from '@ant-design/icons';

const defaultUpsell = () =>
  Modal.info({
    title: 'Plan Pro',
    content:
      'Esta función es parte del plan Pro de LiftLogic (circuito comercial conectado, árbol de componentes y dashboards avanzados). Contactá a tu administrador para activarlo.',
    okText: 'Entendido',
  });

export default function UpgradeToProButton({ size = 'middle', onClick }) {
  return (
    <Button type="primary" size={size} icon={<CrownOutlined />} onClick={onClick || defaultUpsell}>
      Mejorá a Pro
    </Button>
  );
}
